<template>
  <div style="height: calc(100vh - 196px);">
    <vxe-toolbar
      id="toolbarId_cu3"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('complaint_shipper_search_button')"
          @click="funcFilter"
        >
          查询
        </el-button>
        <el-button
          v-if="getLimit('complaint_shipper_export_button')"
          @click="funcExport()"
        >
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      resizable
      stripe
      highlight-current-row
      border
      highlight-hover-row
      :loading="loading"
      height="80%"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="branchCode"
          title="承运主体"
          :formatter="formatterBranch"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.branchCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="mainOrderNumber"
          title="货源单号"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.mainOrderNumber"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="orderCode"
          title="运输单号"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.orderCode"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="driverName"
          title="实际承运人姓名"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.driverName"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="vehicleName"
          title="车牌号"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.vehicleName"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="driverPhone"
          title="实际承运人手机号"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.driverPhone"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="shipmentName"
          title="托运人名称"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.shipmentName"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="shipmentPhone"
          title="托运人手机号"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.shipmentPhone"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="address"
          title="地址"
          min-width="300"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.address"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="isHandle"
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'isHandle')
          "
          title="处理状态"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.isHandle"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in isHandleOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="abnormalType"
          title="投诉原因"
          min-width="100"
          sortable
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'abnormalType')
          "
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.abnormalType"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in abnormalTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="abnormalRemark"
          title="投诉说明"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.abnormalRemark"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="handleIdea"
          title="处理结果"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.handleIdea"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="abnormalFeedback"
          title="结果反馈"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.abnormalFeedback"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="satisfy"
          title="满意度"
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'satisfy')
          "
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select v-model="listQuery.satisfy" clearable placeholder="请选择">
            <el-option
              v-for="item in satisfyOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="occurrenceTime"
          title="发生时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.occurrenceTimeRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'occurrenceTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="handleTime"
          title="处理时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.handleTimeRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'handleTime')"
          />
        </template>
      </vxe-table-column>

      <vxe-table-column title="操作" min-width="100" fixed="right">
        <template slot-scope="scope">
          <el-tooltip
            v-if="getLimit('complaint_shipper_detail_button')"
            class="item"
            effect="dark"
            content="详情"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="code => showModel(scope.row, 'Detail')"
            >
              <i class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              getLimit('complaint_shipper_handle_button') &&
                scope.row.isHandle === 0
            "
            class="item"
            effect="dark"
            content="立即处理"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="code => showModel(scope.row, 'Edit')"
            >
              <i class="el-icon-coordinate" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />

    <vxe-modal
      v-model="modelDetailFlag"
      title="投诉详情"
      width="800"
      height="800"
      resize
    >
      <compDetail ref="DetailRef" />
    </vxe-modal>
    <vxe-modal
      v-model="modelEditFlag"
      title="立即处理"
      width="800"
      height="800"
      resize
    >
      <compEdit ref="EditRef" @hideModel="hideModel" />
    </vxe-modal>
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import { AbnormalList } from "@/api/transport";

import compDetail from "./components/detail.vue";
import compEdit from "./components/edit.vue";
import { getDictByType } from "@/api/commonApi";
export default {
  name: "Driver",
  components: {
    compDetail,
    compEdit
  },
  data() {
    return {
      exportObj: {
        exportUrl:
          "/ntocc-basic-api/orderDetailAbnormal/exportOrderDetailAbnormalShipmentList", //导出接口
        name: "托运人投诉"
      },
      dicts: { abnormalType: {} },
      loading: false,
      tableData: [],
      modelDetailFlag: false,
      modelEditFlag: false,
      listQuery: {
        occurrenceTimeRange: "",
        handleTimeRange: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0,
        abnormalFrom: 0,
        abnormalFeedback: ""
      },
      // 处理状态
      isHandleOptions: [
        { label: "待处理", value: 0 },
        { label: "已处理", value: 1 }
      ],
      // 满意度
      satisfyOptions: [
        { label: "未评价", value: 0 },
        { label: "满意", value: 1 },
        { label: "不满意", value: 2 }
      ],
      abnormalTypeOptions: [],
      //机构信息
      branchList: this.$store.state.components.branchList
    };
  },
  async created() {
    this.dicts = await getDictByType("abnormalType");
    let abnormalType = this.dicts.abnormalType;
    Object.keys(abnormalType).forEach(key => {
      let obj = { label: abnormalType[key], value: key };
      this.abnormalTypeOptions.push(obj);
    });
    this.findList();
  },
  methods: {
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        AbnormalList(this.listQuery).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.loading = false;
          resolve();
        });
      });
    },
    // 处理状态
    formatterIsHandle({ cellValue }) {
      const item = this.isHandleOptions.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    formatterField({ cellValue }, prefix) {
      const item = this[`${prefix}Options`].find(
        item => item.value == cellValue
      );
      return item ? item.label : "";
    },

    // 展示弹框
    showModel(row, prefix) {
      this.$refs[`${prefix}Ref`].getInfo(row.code);
      this[`model${prefix}Flag`] = true;
    },
    // 隐藏弹框
    hideModel() {
      this.modelDetailFlag = false;
      this.modelEditFlag = false;
      this.findList();
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item => item.code === cellValue);
      return item ? item.groupName : "";
    }
  }
};
</script>
